/** @jsx jsx */
import { jsx } from '@emotion/react'
import { css } from '@emotion/react/macro'
import React from 'react'
import { motion, Variants } from 'framer-motion'

const rippleChildCss = css`
  opacity: 1;
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: currentColor;
`

type RippleProps = {
  pulsate?: boolean
  size: number
  x: number
  y: number
}

const defaultProps: Pick<RippleProps, 'pulsate'> = {
  pulsate: false
}

const easeInOut = [0.4, 0, 0.2, 1]
const Ripple = ({ pulsate, x, y, size }: RippleProps) => {
  const rippleCss = css`
    position: absolute;
    width: ${size}px;
    height: ${size}px;
    top: ${-(size / 2) + y}px;
    left: ${-(size / 2) + x}px;
  `
  const variants: Variants = {
    touch: {
      opacity: 0.3,
      scale: 1,
      transition: { duration: 0.55, ease: easeInOut }
    },
    pulsate: {
      opacity: [0.3, 0.3, 0.3],
      scale: [1, 0.92, 1],
      transition: { duration: 1.5, loop: Infinity, ease: easeInOut }
    }
  }
  return (
    <span css={rippleCss}>
      <motion.span
        key="child"
        animate={pulsate ? 'pulsate' : 'touch'}
        css={rippleChildCss}
        exit={{ opacity: 0, transition: { duration: 0.5, ease: easeInOut } }}
        initial={{ opacity: 0.1, scale: 0 }}
        variants={variants}
      />
    </span>
  )
}

Ripple.defaultProps = defaultProps

export default React.memo(Ripple)
